export enum ColorLegendItemType {
  Color,
  Background,
  Icon,
  Flag,
  Text,
  Image
}